import React, { useEffect } from 'react';
import { useNavigationContext } from '../../context/NavigationContext';
import Table from './PostsTable';
import { ConfirmationModalContextProvider } from '../../context/ConfirmationModalContext';

const Posts = (props) => {
  const { zone: zoneId } = props.match.params;

  const { setNavigationActivated } = useNavigationContext();
  useEffect(() => {
    setNavigationActivated(true);
  }, []);

  return (
    <ConfirmationModalContextProvider>
      <div id="posts">
        <Table zoneId={zoneId} />
      </div>
    </ConfirmationModalContextProvider>
  );
};

export default Posts;
